import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  CardTitle,
  Form,
  FormGroup,
  FormText,
  Input,
  Table,
  Row,
  Col
} from "reactstrap";

import axios from "axios";

import { Redirect } from "react-router-dom";

import { PanelHeader, Button } from "components";

import { theadcustomers, tbody } from "variables/general";
import SweetAlert from "react-bootstrap-sweetalert";
import { Link } from "react-router-dom";
// react plugin used to create charts
import { Line } from "react-chartjs-2";
import { dashboardPanelChart } from "variables/charts.jsx";

var dashboardOrdersTitleStyle = {
  margin: "0 0 20px 20px",
  color: "#FFF"
};
var isExternal = false;

var checkIBAN = (function() {
  // use an IIFE
  // A "constant" lookup table of IBAN lengths per country
  // (the funky formatting is just to make it fit better in the answer here on CR)
  var CODE_LENGTHS = {
    AD: 24, AE: 23, AT: 20, AZ: 28, BA: 20, BE: 16, BG: 22, BH: 22, BR: 29,
    CH: 21, CR: 21, CY: 28, CZ: 24, DE: 22, DK: 18, DO: 28, EE: 20, ES: 24,
    FI: 18, FO: 18, FR: 27, GB: 22, GI: 23, GL: 18, GR: 27, GT: 28, HR: 21,
    HU: 28, IE: 22, IL: 23, IS: 26, IT: 27, JO: 30, KW: 30, KZ: 20, LB: 28,
    LI: 21, LT: 20, LU: 20, LV: 21, MC: 27, MD: 24, ME: 22, MK: 19, MR: 27,
    MT: 31, MU: 30, NL: 18, NO: 15, PK: 24, PL: 28, PS: 29, PT: 25, QA: 29,
    RO: 24, RS: 22, SA: 24, SE: 24, SI: 19, SK: 24, SM: 27, TN: 24, TR: 26
  };

  // piece-wise mod97 using 9 digit "chunks", as per Wikipedia's example:
  // http://en.wikipedia.org/wiki/International_Bank_Account_Number#Modulo_operation_on_IBAN
  function mod97(string) {
    var checksum = string.slice(0, 2),
        fragment;

    for(var offset = 2 ; offset < string.length ; offset += 7) {
      fragment = String(checksum) + string.substring(offset, offset + 7);
      checksum = parseInt(fragment, 10) % 97;
    }

    return checksum;
  }

  // return a function that does the actual work
  return function (input) {
    var iban = String(input).toUpperCase().replace(/[^A-Z0-9]/g, ''), // keep only alphanumeric characters
        code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/),           // match and capture (1) the country code, (2) the check digits, and (3) the rest
        digits;

    // check syntax and length
    if(!code || iban.length !== CODE_LENGTHS[code[1]]) {
      return false;
    }

    // rearrange country code and check digits, and convert chars to ints
    digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, function (letter) {
      return letter.charCodeAt(0) - 55;
    });

    // final check
    return mod97(digits) === 1;
  };
}());

class CustomersList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      downloading: {},
      showDetail: false,
      orderDetail: null,
      ordersChartReady: false,
      ordersHistoryTitle: "Histórico de facturas",
      toDashboard: false,
      searchQuery: "",
      shownNotifications: []
    };
    ////console.log(props);
    this.viewOrderArticles = this.viewOrderArticles.bind(this);
    this.searchCustomer = this.searchCustomer.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.createServicesButtons = this.createServicesButtons.bind(this);
    this.redirectTo = this.redirectTo.bind(this);
    let externalUsers = [
      "Oniti"
    ];
    if (externalUsers.indexOf(this.props.mainState.user.name) > -1) {
      isExternal = true;
    }
  }
  searchCustomer() {
    if (!this.props.mainState.isSearchingCustomer)
      this.props.searchCustomer(this.state.searchQuery, null, null, true);
  }
  downloadBill(url, orderNumber, event) {
    this.setState({
      [orderNumber]: true
    });
    axios({
      url: url,
      method: "GET",
      responseType: "blob" // important
    }).then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        "factura_nadunet_".concat(orderNumber).concat(".pdf")
      );
      document.body.appendChild(link);
      link.click();
      this.setState({
        [orderNumber]: false
      });
    });
  }
  hideAlert() {
    this.setState({
      alert: null
    });
  }
  goToDashboard() {
    this.setState({
      toDashboard: true
    });
  }
  paymentStatus(payment) {
    let statusReady = null;
    if (payment.includes("Pendiente")) {
      statusReady = (
        <Button color="danger" size="sm">
          <i className="now-ui-icons ui-1_simple-remove" /> {payment}
        </Button>
      );
    } else {
      statusReady = (
        <Button color="primary" size="sm">
          <i className="now-ui-icons ui-1_check" /> {payment}
        </Button>
      );
    }

    return statusReady;
  }
  downloadButton(order) {
    let button = (
      <div>
        <i className="now-ui-icons arrows-1_cloud-download-93" /> PDF
      </div>
    );

    if (this.state[order]) {
      button = (
        <div>
          <i className="now-ui-icons arrows-1_refresh-69 spin" />
        </div>
      );
    }

    return button;
  }
  handleChange(field, event) {
    this.setState({ [field]: event.target.value });
  }
  viewOrderArticles(order) {
    let orderDetailContent = (
      <div>
        <Table responsive>
          <thead>
            <tr className="text-primary">
              <th className="text-center">Concepto</th>
              <th className="text-center">Precio</th>
            </tr>
          </thead>
          <tbody>
            {this.props.mainState.ordersArticles[order].map((article, key) => {
              return (
                <tr key={key}>
                  <td className="text-center">{article.titulo}</td>
                  <td className="text-center">{article.total}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
    this.setState({
      orderDetail: orderDetailContent,
      showDetail: true
    });
  }
  validateIBAN(iban) {
    return checkIBAN(iban) && iban.replace(/ /g, "").length === 24;
  }
  createServicesButtons(customer) {
    let buttons = [];
    if (!this.props.mainState.customersMobilesLoaded) {
      buttons.push(
        <Button
          key={"mobileButton" + customer.id}
          round
          color="default"
          size="sm"
          icon
          /* onClick={e =>
            this.viewOrderArticles(order.numero_pedido, e)
          } */
        >
          <div>
            <i className="now-ui-icons arrows-1_refresh-69 spin reposition-spin" />
          </div>
        </Button>
      );
    } else {
      let mobilesQuantity = 0;
      let mobilesText = null;
      if (customer.id in this.props.mainState.customersMobiles) {
        mobilesQuantity = this.props.mainState.customersMobiles[customer.id]
          .length;
        // if (mobilesQuantity > 0) mobilesText = mobilesQuantity.toString();
      }

      buttons.push(
        <Button
          key={"mobileButton" + customer.id}
          round
          icon
          color={mobilesQuantity > 0 ? "primary" : "default"}
          size="sm"
          /* onClick={e =>
            this.viewOrderArticles(order.numero_pedido, e)
          } */
        >
          <div>
            <i className="now-ui-icons tech_mobile" /> {mobilesText}
          </div>
        </Button>
      );
    }

    if (buttons.length > 0) buttons.push("  ");

    buttons.push(
      <Button
        key={"internetButton" + customer.id}
        round
        icon
        color={customer.internet_activo == "1" ? "info" : "default"}
        size="sm"
        /* onClick={e =>
          this.viewOrderArticles(order.numero_pedido, e)
        } */
      >
        <div>
          <i className="now-ui-icons location_world" />
        </div>
      </Button>
    );

    let renewalIcon = "now-ui-icons business_money-coins";
    let renewalColor = customer.renovar_activo === "1" ? (this.validateIBAN(customer.cuenta_bancaria) ? "primary" : "warning") : "danger";
    if (renewalColor === "warning" && customer.metodo_pago !== "Domiciliación bancaria") renewalColor = "primary";
    if (renewalColor === "warning" && !(customer.id in this.state.shownNotifications)) {
      let customerNameLink = 
        <Link 
          key={"enlace-" + customer.id} 
          className="txt-white" 
          to={"/clientes/fichas/".concat(customer.id)}>
            <b>
              {[customer.nombre_completo, customer.primer_apellido, customer.segundo_apellido].join(" ")}
            </b>
        </Link>;
      
      let becariosUsers = [
        "Miguel.Zarzo-nadunet"
      ];
      // console.log("Comprobando becario en lista de clientes", this.props.mainState.user.name);
      if (becariosUsers.indexOf(this.props.mainState.user.name)  > -1) {
        // console.log("Es becario en lista de clientes");
        customerNameLink = 
        <Link 
          key={"enlace-" + customer.id} 
          className="txt-white" 
          to={"#"}>
            <b>
              {[customer.nombre_completo, customer.primer_apellido, customer.segundo_apellido].join(" ")}
            </b>
        </Link>;
      }

      let notificationText = [];
      notificationText.push(customerNameLink);
      notificationText.push(" tiene mal la cuenta bancaria");
      let options = {
        place: "tr",
        message: notificationText,
        type: "warning",
        icon: "now-ui-icons ui-1_bell-53",
        autoDismiss: 10
      };
      this.props.showNotification(options);
      let shownNotificationsAux = this.state.shownNotifications;
      shownNotificationsAux[customer.id] = true;
      this.setState({
        shownNotifications: shownNotificationsAux
      });
    }
    if (buttons.length > 0) buttons.push("  ");
    buttons.push(
      <Button
        key={"renewButton" + customer.id}
        round
        icon
        color={renewalColor}
        size="sm"
        /*onClick={() => {
          this.props.switchCustomerRenewal(customer.id, customer.renovar_activo !== "1");
        }}*/
      >
        <div>
          <i className={renewalIcon} />
        </div>
      </Button>
    );

    return buttons;
  }
  createActiveCustomerButton(customer) {
    let button = undefined;
    if (customer.renovar_activo === "1") {
      button = (
        <Button
          color="primary"
          size="sm"
          /* onClick={e =>
          this.viewOrderArticles(order.numero_pedido, e)
        } */
        >
          <div>
            <i className="now-ui-icons ui-1_check" /> Activo
          </div>
        </Button>
      );
    } else {
      button = (
        <Button
          color="default"
          size="sm"
          /* onClick={e =>
          this.viewOrderArticles(order.numero_pedido, e)
        } */
        >
          <div>
            <i className="now-ui-icons media-1_button-pause" /> Inactivo
          </div>
        </Button>
      );
    }

    return button;
  }
  redirectTo(redirect) {
    this.props.history.push(redirect);
  }
  render() {
    let sortedMonths = this.props.mainState.customersLastMonths.sort(
      (a, b) =>
        new Date(...a.month.split("-").reverse()) -
        new Date(...b.month.split("-").reverse())
    );
    //console.log(sortedMonths);
    if (this.state.toDashboard === true) {
      this.redirectTo("/dashboard");
      // return <Redirect to="/dashboard" />;
    }
    //console.log(this.props.mainState.customers);
    //console.log(this.props.mainState.customers.length);
    //if (this.props.mainState.ordersLoaded && !this.state.ordersChartReady && this.props.mainState.orders.length > 0) this.loadCustomersChart();
    let contentToDisplay = null;
    let customersToDisplay = null;
    if (
      !this.props.mainState.isSearchCustomerResult &&
      this.props.mainState.customersLoaded &&
      Object.keys(this.props.mainState.customers).length > 0
    ) {
      customersToDisplay = this.props.mainState.customers;
      //console.log("######## CUSTOMERS TO DISPLAY #######");
      //console.log(customersToDisplay);
      contentToDisplay = (
        <Col xs={12}>
          <Card>
            <CardHeader>
              <CardTitle tag="h4">Lista de clientes</CardTitle>
            </CardHeader>
            <CardBody>
              <Table responsive>
                <thead>
                  <tr className="text-primary">
                    {theadcustomers.map((prop, key) => {
                      if (key === theadcustomers.length - 1)
                        return (
                          <th key={key} className="text-center">
                            {prop}
                          </th>
                        );
                      return (
                        <th key={key} className="text-center">
                          {prop}
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(customersToDisplay)
                    .sort(function(a, b) {
                      return b - a;
                    })
                    .map((customerKey, key) => {
                      let customer = customersToDisplay[customerKey][0];
                      // console.log("Rendering user row, isExternal: ", isExternal);
                      // console.log("Rendering user row, this.props.mainState.user.name: ", this.props.mainState.user.name);
                      // console.log("Rendering user row, customer.distribuidor: ", customer.distribuidor);
                      if (isExternal && customer.distribuidor !== this.props.mainState.user.name) return null;
                      let servicesButtons = this.createServicesButtons(
                        customer
                      );
                      let activeCustomerButton = this.createActiveCustomerButton(
                        customer
                      );
                      let formattedNumber = "";
                      if (customer.phone) {
                        formattedNumber =
                          customer.phone.substring(0, 3) +
                          " " +
                          customer.phone.substring(3, 6) +
                          " " +
                          customer.phone.substring(6, 9);
                      }
                      let customerURL = "/clientes/fichas/".concat(customer.id);
                      let becariosUsers = [
                        "Miguel.Zarzo-nadunet"
                      ];
                      // console.log("Comprobando becario en lista de clientes. Crear URL: ", this.props.mainState.user.name);
                      if (becariosUsers.indexOf(this.props.mainState.user.name)  > -1) {
                        // console.log("Es becario en lista de clientes");
                        customerURL = "#";
                      }
                      return (
                        <tr key={customer.id}>
                          <td className="text-center">
                            {activeCustomerButton}
                          </td>
                          <td className="text-left">{customer.creacion}</td>
                          <td className="text-left">
                            <Link to={customerURL}>
                              {customer.nombre_completo}{" "}
                              {customer.primer_apellido}{" "}
                              {customer.segundo_apellido}
                            </Link>
                          </td>
                          <td className="text-left">{formattedNumber}</td>
                          <td className="text-left">{customer.nif}</td>
                          {/*<td className="text-left">{customer.email}</td>*/}
                          <td className="text-left">{customer.domicilio.replace("&#039;", "'")}</td>
                          <td className="text-left">{customer.localidad}</td>
                          <td className="text-left">{customer.distribuidor}</td>
                          <td className="text-center">{servicesButtons}</td>
                          {/* order.data.map((prop, key) => {
                            if (key === thead.length - 1)
                              return (
                                <td key={key} className="text-right">
                                  {prop}
                                </td>
                              );
                            return <td key={key}>{prop}</td>;
                          }) */}
                        </tr>
                      );
                    })}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>
      );
    } else if (
      this.props.mainState.isSearchCustomerResult &&
      this.props.mainState.customersLoaded &&
      this.props.mainState.searchCustomerQuery in
        this.props.mainState.customerSearchResult &&
      Object.keys(
        this.props.mainState.customerSearchResult[
          this.props.mainState.searchCustomerQuery
        ]
      ).length > 0
    ) {
      customersToDisplay = this.props.mainState.customerSearchResult[
        this.props.mainState.searchCustomerQuery
      ];
      //console.log("######## CUSTOMERS TO DISPLAY #######");
      //console.log(customersToDisplay);
      contentToDisplay = (
        <Col xs={12}>
          <Card>
            <CardHeader>
              <CardTitle tag="h4">Lista de clientes</CardTitle>
            </CardHeader>
            <CardBody>
              <Table responsive>
                <thead>
                  <tr className="text-primary">
                    {theadcustomers.map((prop, key) => {
                      if (key === theadcustomers.length - 1)
                        return (
                          <th key={key} className="text-center">
                            {prop}
                          </th>
                        );
                      return (
                        <th key={key} className="text-center">
                          {prop}
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(customersToDisplay)
                    .sort(function(a, b) {
                      return b - a;
                    })
                    .map((customerKey, key) => {
                      let customer = customersToDisplay[customerKey][0];
                      // console.log("Rendering user row, isExternal: ", isExternal);
                      // console.log("Rendering user row, this.props.mainState.user.name: ", this.props.mainState.user.name);
                      // console.log("Rendering user row, customer.distribuidor: ", customer.distribuidor);
                      if (isExternal && customer.distribuidor !== this.props.mainState.user.name) return null;
                      let servicesButtons = this.createServicesButtons(
                        customer
                      );
                      let activeCustomerButton = this.createActiveCustomerButton(
                        customer
                      );
                      let formattedNumber = "";
                      if (customer.phone) {
                        formattedNumber =
                          customer.phone.substring(0, 3) +
                          " " +
                          customer.phone.substring(3, 6) +
                          " " +
                          customer.phone.substring(6, 9);
                      }
                      let customerURL = "/clientes/fichas/".concat(customer.id);
                      let becariosUsers = [
                        "Miguel.Zarzo-nadunet"
                      ];
                      // console.log("Comprobando becario en lista de clientes. Crear URL: ", this.props.mainState.user.name);
                      if (becariosUsers.indexOf(this.props.mainState.user.name)  > -1) {
                        // console.log("Es becario en lista de clientes");
                        customerURL = "#";
                      }
                      return (
                        <tr key={customer.id}>
                          <td className="text-center">
                            {activeCustomerButton}
                          </td>
                          <td className="text-left">{customer.creacion}</td>
                          <td className="text-left">
                            <Link to={customerURL}>
                              {customer.nombre_completo}{" "}
                              {customer.primer_apellido}{" "}
                              {customer.segundo_apellido}
                            </Link>
                          </td>
                          <td className="text-left">{formattedNumber}</td>
                          <td className="text-left">{customer.nif}</td>
                          {/*<td className="text-left">{customer.email}</td>*/}
                          <td className="text-left">{customer.domicilio.replace("&#039;", "'")}</td>
                          <td className="text-left">{customer.localidad}</td>
                          <td className="text-left">{customer.distribuidor}</td>
                          <td className="text-center">{servicesButtons}</td>
                          {/* order.data.map((prop, key) => {
                            if (key === thead.length - 1)
                              return (
                                <td key={key} className="text-right">
                                  {prop}
                                </td>
                              );
                            return <td key={key}>{prop}</td>;
                          }) */}
                        </tr>
                      );
                    })}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>
      );
    } else if (
      !this.props.mainState.isSearchCustomerResult &&
      this.props.mainState.customersLoaded &&
      Object.keys(this.props.mainState.customers).length == 0
    ) {
      contentToDisplay = null;
      // contentToDisplay = (
      //   <SweetAlert
      //     danger
      //     style={{ display: "block", marginTop: "-250px" }}
      //     title="¡No tienes clientes!"
      //     onConfirm={() => this.goToDashboard()}
      //     onCancel={() => this.goToDashboard()}
      //     confirmBtnBsStyle="info"
      //   >
      //     Todavía no tienes ningún cliente, tan pronto como los tengas,
      //     aparecerán aquí.
      //   </SweetAlert>
      // );
    } else if (
      this.props.mainState.isSearchCustomerResult &&
      this.props.mainState.customersLoaded &&
      this.props.mainState.searchCustomerQuery in
        this.props.mainState.customerSearchResult &&
      Object.keys(
        this.props.mainState.customerSearchResult[
          this.props.mainState.searchCustomerQuery
        ]
      ).length == 0
    ) {
      contentToDisplay = (
        <Col xs={12}>
          <Card>
            <CardHeader>
              <CardTitle tag="h4">Lista de clientes</CardTitle>
            </CardHeader>
            <CardBody>
              <Row>
                {/*<Label sm={2}>Buscar</Label>*/}
                <Col xs={12} sm={10}>
                  No hay resultados para{" "}
                  <b>{this.props.mainState.searchCustomerQuery}</b>...
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      );
    } else {
      contentToDisplay = (
        <SweetAlert
          style={{ display: "block", marginTop: "-100px" }}
          title="¡Un momentito!"
          onConfirm={() => this.hideAlert()}
          showConfirm={false}
        >
          <i className="now-ui-icons arrows-1_refresh-69 spin" />
          {"  Cargando clientes..."}
        </SweetAlert>
      );
    }

    let orderArticles = (
      <SweetAlert
        style={{ display: "block", marginTop: "-100px" }}
        title="Detalles de la factura"
        onConfirm={() => this.hideDetail()}
        showConfirm={true}
      >
        {this.state.orderDetail}
      </SweetAlert>
    );

    let createCustomerButton = (
      <Link to={"/clientes/crear"}>
        <Button round color="info">
          <i className="now-ui-icons ui-1_simple-add" /> Crear cliente
        </Button>
      </Link>
    );
    
    let becariosUsers = [
      "Miguel.Zarzo-nadunet"
    ];
    // console.log("Comprobando becario en lista de clientes -> Botón: ", this.props.mainState.user.name);
    if (becariosUsers.indexOf(this.props.mainState.user.name)  > -1) {
      // console.log("Es becario en lista de clientes -> Botón");
      createCustomerButton = null;
    }

    return (
      <div>
        <PanelHeader
          size="sm"
          /* content={
            <div className="header text-center">
              <h2 className="title">Lista de clientes</h2>
              {<p className="category"></p>}
            </div>
          }*/
        />
        <div className="content">
          <Row>
            <Col lg={3} md={6} xs={12}>
              <Card>
                <CardBody className="form-inline">
                  <Input
                    type="text"
                    placeholder="Buscar cliente..."
                    value={this.state.searchQuery}
                    onChange={e => this.handleChange("searchQuery", e)}
                    onKeyDown={e => {
                      //console.log(e.keyCode);
                      if (e.keyCode == 13) {
                        //Enter is key code 13
                        this.searchCustomer();
                        // put the login here
                      }
                    }}
                    style={{ marginRight: "10px" }}
                  />
                  <Button
                    color={
                      this.props.mainState.isSearchingCustomer
                        ? "default"
                        : "primary"
                    }
                    round
                    icon
                    onClick={this.searchCustomer}
                  >
                    <i
                      className={
                        this.props.mainState.isSearchingCustomer
                          ? "now-ui-icons arrows-1_refresh-69 spin reposition-spin"
                          : "now-ui-icons ui-1_zoom-bold"
                      }
                    />
                  </Button>
                </CardBody>
              </Card>
            </Col>
            <Col lg={3} md={6} xs={12}>
              {createCustomerButton}
            </Col>
            {/*<Label sm={2}>Buscar</Label>*/}
          </Row>
          <Row>
            {this.state.showDetail && orderArticles}
            {contentToDisplay}
          </Row>
        </div>
      </div>
    );
  }
}

export default CustomersList;



// WEBPACK FOOTER //
// ./src/views/Customers/CustomersList.jsx